import { i18nTranslationHelper } from '@/i18n'

const t = i18nTranslationHelper.getTEnums

export namespace LearningGoal {
  export class Enum {
    static readonly IMPROVE_CURRENT_SKILLS = new Enum(
      'IMPROVE_CURRENT_SKILLS',
      t('learningGoal.IMPROVE_CURRENT_SKILLS.title')
    )

    static readonly ACHIEVE_PROMOTION = new Enum(
      'ACHIEVE_PROMOTION',
      t('learningGoal.ACHIEVE_PROMOTION.title')
    )

    static readonly EXPLORE_NEW_AREAS = new Enum(
      'EXPLORE_NEW_AREAS',
      t('learningGoal.EXPLORE_NEW_AREAS.title')
    )

    static readonly BECOME_LEADER = new Enum('BECOME_LEADER', t('learningGoal.BECOME_LEADER.title'))

    static readonly LEARN_THEMES_OF_INTEREST = new Enum(
      'LEARN_THEMES_OF_INTEREST',
      t('learningGoal.LEARN_THEMES_OF_INTEREST.title')
    )

    static readonly OTHER = new Enum('OTHER', t('learningGoal.OTHER.title'))

    static readonly UNDEFINED = new Enum('UNDEFINED', t('learningGoal.UNDEFINED.title'))

    public constructor(
      public readonly name: string,
      public readonly title: string
    ) {}
  }

  export const getAll = (): Enum[] => Object.values(Enum)

  export const getByName = (name: string | null): Enum | null =>
    name && Object.values(Enum).find(type => type.name === name)
}
